import { FC, Dispatch, SetStateAction, useState, useEffect, useCallback } from 'react'
import {
    FlexDiv,
    OrangeButton,
    OrangeButtonSimpleText,
} from '../index'
import { FirmDetailsUpdateAddressInputs } from 'src/dtos/portal'
import StandardInput from 'src/components/basic/StandardInput'
import { object, string } from 'yup'
import StandardSelect from 'src/components/basic/StandardSelect'
import { states } from 'src/constants/application'

interface FirmViewEditAddressProps {
  editAddressInputs: FirmDetailsUpdateAddressInputs;
  setEditAddressInputs: Dispatch<SetStateAction<FirmDetailsUpdateAddressInputs>>;
  handleCancel: () => void;
  handleSave: () => Promise<void>;
}

const FirmViewEditAddress: FC<FirmViewEditAddressProps> = ({
  editAddressInputs,
  setEditAddressInputs,
  handleCancel,
  handleSave
}) => {
  const [saveBtnDisabled, setSaveBtnDisabled] = useState(true)
  const [isSaving, setIsSaving] = useState(false)

  const validationSchema = object({
    line1: string().required(),
    city: string().required(),
    postalCode: string().required(),
  })

  const validateAddress = useCallback(() => {
    try {
      validationSchema.validateSync(editAddressInputs)

      setSaveBtnDisabled(false)
    } catch(e) {
      setSaveBtnDisabled(true)
    }
  }, [editAddressInputs, validationSchema])

  useEffect(() => {
    validateAddress()
  }, [validateAddress])

  const handleSaveAddress = async () => {
    setIsSaving(true)
    await handleSave()
    setIsSaving(false)
  }
  
  return (
    <FlexDiv margin="24px 0 0" align='flex-start' gap="144px">
      <FlexDiv dir="column" gap="24px">
        <FlexDiv dir="row" gap="24px">
          <FlexDiv maxWidth='120px'>
            <StandardInput
              label="Street Number"             
              value={editAddressInputs.streetNumber}
              onChange={e => setEditAddressInputs(prev => ({ ...prev, streetNumber: e.target.value }))}
            />
            </FlexDiv>
            <StandardInput
                label="Street Address Line 1"
                value={editAddressInputs.line1}
                onChange={e => setEditAddressInputs(prev => ({ ...prev, line1: e.target.value }))}
              />
        </FlexDiv>  
        <StandardInput
          label="Street Address Line 2"
          value={editAddressInputs.line2}
          onChange={e => setEditAddressInputs(prev => ({ ...prev, line2: e.target.value }))}
        />
        <StandardInput
          label="Suite/Unit #"
          value={editAddressInputs.suiteNumber}
          onChange={e => setEditAddressInputs(prev => ({ ...prev, suiteNumber: e.target.value }))}
        />
        <FlexDiv gap="24px">
          <StandardInput
            label="City"
            value={editAddressInputs.city}
            onChange={e => setEditAddressInputs(prev => ({ ...prev, city: e.target.value }))}
          />
          <FlexDiv maxWidth='120px'>
            {/* <StandardInput
              label="State"
              disabled
              value={editAddressInputs.state}
            /> */}
            <StandardSelect
                    label='State'
                    name="state"
                    value={editAddressInputs.state}
                    onChange={e => setEditAddressInputs(prev => ({ ...prev, state: e.target.value }))}
                    // isIncorrect={isIncorrect && !address?.addressComponents?.find(item => item?.types?.includes('state'))?.shortName}
                    // errorMessage={isIncorrect && !address?.addressComponents?.find(item => item?.types?.includes('state'))?.shortName ? 'This is a required field' : ''}
                     >
                    <option disabled value="">Select</option>
                    {states.map((position, index) => (
                      <option key={index} value={position.abbreviation}>{position.name}</option>
                  ))}
                </StandardSelect>
          </FlexDiv>
          <StandardInput
            label="Postal Code"
            value={editAddressInputs.postalCode}
            onChange={e => setEditAddressInputs(prev => ({ ...prev, postalCode: e.target.value }))}
          />
        </FlexDiv>
      </FlexDiv>
      <FlexDiv maxWidth='fit-content' gap="24px" align='center'>
        <OrangeButtonSimpleText onClick={handleCancel} disabled={isSaving}>
          Cancel
        </OrangeButtonSimpleText>
        <OrangeButton
          disabled={isSaving ? true : saveBtnDisabled}
          onClick={handleSaveAddress}
        >
          Save
        </OrangeButton>
      </FlexDiv>
    </FlexDiv>
  )
}

export default FirmViewEditAddress